// const base64Regex = /^data:image\/[a-z]+;base64,/;
const base64Regex = /data:[A-Za-z0-9+/=]+;base64,/;
export default base64Regex;
